import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextBox from '../../../../components/common/TextBox';
import ColorButton from '../../../../components/common/ColorButton';
import FlexLayout from '../../../../components/common/FlexLayout';
import ApplyButton from '../../../../components/common/ApplyButton';

const Text = ({
  options,
  initialSelectedCustomizationIndex,
  updatePartsConfig,
  setCurrentText,
  setIsConfigSaved,
  selectedPart,
  currentText
}) => {
  // const [activeColor, setActiveColor] = useState(
  //   initialSelectedCustomizationIndex
  // );
  const [line1, setLine1] = useState(currentText[0].line);
  const [line2, setLine2] = useState(currentText[1].line);

  const [isTextFirstChanging, setIsTextFirstChanging] = useState(false);
  const [isTextSecondChanging, setIsTextSecondChanging] = useState(false);

  // useEffect(() => {
  //   setActiveColor(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);
  return (
    <div className="text-type">
      <div className="text-type_tb">
        <TextBox
          name="text-1"
          placeholder="type line 1 here"
          maxLength={14}
          value={line1}
          onChange={value => {
            setLine1(value);
            setIsTextFirstChanging(true);
          }}
        />
      </div>
      <div
        className="text-type_btn"
        style={{ opacity: isTextFirstChanging ? 1 : 0.3 }}
      >
        <ApplyButton
          label="apply"
          onClick={() => {
            const rotateTo = options.filter(
              option => option.partId === selectedPart
            )[0].configData.defaultView;
            setCurrentText(
              [{ line: line1, fontSize: 20 }, currentText[1]],
              rotateTo
            );
            setIsConfigSaved();
            setIsTextFirstChanging(false);
          }}
        />
      </div>
      <div className="text-type_tb">
        <TextBox
          name="text-2"
          placeholder="type line 2 here"
          maxLength={20}
          value={line2}
          onChange={value => {
            setLine2(value);
            setIsTextSecondChanging(true);
          }}
        />
      </div>
      <div
        className="text-type_btn"
        style={{ opacity: isTextSecondChanging ? 1 : 0.3 }}
      >
        <ApplyButton
          label="apply"
          onClick={() => {
            const rotateTo = options.filter(
              option => option.partId === selectedPart
            )[0].configData.defaultView;
            setCurrentText(
              [currentText[0], { line: line2, fontSize: 14 }],
              rotateTo
            );
            setIsConfigSaved();
            setIsTextSecondChanging(false);
          }}
        />
      </div>
      <h6 className="text-type_text">choose your text color</h6>
      <FlexLayout flexDirection="row" justifyContent="flex-start">
        {options &&
          options.map((color, i) => (
            <div className="text-type_color">
              <ColorButton
                isSelected={selectedPart === color.partId}
                color={color.configData.hex}
                text={color.configData.label}
                onClick={() => {
                  // setActiveColor(i);
                  updatePartsConfig(options[i]);
                }}
              />
            </div>
          ))}
      </FlexLayout>
    </div>
  );
};

Text.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  setCurrentText: PropTypes.func,
  currentText: PropTypes.array
};

export default Text;
